import React from 'react';
import Publication from './Publication';

function Home() {

    return (
        <div>

            <div className="jumbotron d-flex align-items-center">
                <div className="row d-flex align-items-center mt-2">
                    <div className="col-3">
                        <img className="img-responsive w-100 rounded-circle" src="img/profile.png"/>
                    </div>
                    <div className="col-9">
                        <h1 className="display-3 mt-5">Pete Meltzer</h1>
                        <p>PhD Student (University College London) and GAMMA Technical Lead (Braintree Ltd).</p>
                    </div>
                </div>
            </div>


            <div className="container">

                <h2 className="mt-5">Research Interests</h2>
                <p className="text-justify">I believe graphs are the most fundamental data structure for the abstraction
                    of
                    the
                    systems and information
                    that form the world around us. The generality and flexibility of graphs enable us to model the most
                    simple
                    and the most complex of phenomena in an intuitive manner. Because of this, I believe that they offer
                    a path
                    to generalising artificial intelligence, and as such I have a strong interest in all forms of
                    machine
                    learning on graph structured data, graph representation learning, and the scalable computation of
                    such
                    models.</p>
                <p className="text-justify">If want to discuss graphs and ML at all, feel free to <a href="#contact">get
                    in touch</a>.</p>

                <h2 className="mt-5">Current Employment</h2>
                <ul>
                    <li>2nd year Computer Science PhD student at UCL, under the supervision of <a
                        href="http://about.peterjbentley.com/">Peter J. Bentley</a> &mdash; Machine learning on
                        graph-structured data.
                    </li>
                    <li>Technical Lead (GAMMA Project) at Braintree Ltd. &mdash; Braintree Ltd. is an AI consultancy and
                        research company
                        that provides innovative solutions for major corporations, public service organisations,
                        government,
                        and individuals. The GAMMA Project is a platform for machine learning and artificial
                        intelligence on
                        graphical data, integrated directly with one of the worlds leading graph databases (<a
                            href="https://neo4j.com/">Neo4j</a>).
                        &mdash; <a href="http://braintree.com">http://braintree.com</a></li>
                </ul>

                <h2 className="mt-5">Qualifications</h2>
                <ul>
                    <li>MSc Computer Science (UCL) &mdash; 1st in class</li>
                    <li>Qualified Teacher Status (QTS)</li>
                    <li>Postgraduate Certificate in Education: Secondary Mathematics (University of Wolverhampton)</li>
                </ul>

                <h2 className="mt-5">Publications</h2>
                <ul>
                    <Publication
                        author={"Meltzer, P., Gutierrez Mallea, M. D. and Bentley, P. J."}
                        date={"2019"}
                        title={"PiNet: A Permutation Invariant Graph Neural Network for Graph Classification."}
                        abstract={"We propose an end-to-end deep learning model for graph classification and representation learning that is invariant to permutation of the nodes of the input graphs. We address the challenge of learning a fixed size graph representation for graphs of varying dimensions through a differentiable node attention pooling mechanism. In addition to a theoretical proof of its invariance to permutation, we provide empirical evidence demonstrating the statistically significant gain in accuracy when faced with an isomorphic graph classification task given only a small number of training examples.\n" +
                        "We analyse the effect of four different matrices to facilitate the local message passing mechanism by which graph convolutions are performed vs. a matrix parametrised by a learned parameter pair able to transition smoothly between the former. Finally, we show that our model achieves competitive classification performance with existing techniques on a set of molecule datasets.\n"}
                        pdf={"https://arxiv.org/pdf/1905.03046.pdf"}
                    />
                    <Publication
                        author={"Gutierrez Mallea, M. D., Meltzer, P. and Bentley, P. J."}
                        date={"2019"}
                        title={"Capsule Neural Networks for Graph Classification using Explicit Tensorial Graph Representations."}
                        abstract={"Graph classification is a significant problem in many scientific domains. It addresses " +
                        "tasks " +
                        "such as the classification of proteins and chemical compounds into categories according " +
                        "to their " +
                        "functions, or chemical and structural properties. In a supervised setting, this problem " +
                        "can be " +
                        "framed as learning the structure, features and relationships between features within a " +
                        "set of " +
                        "labelled graphs and being able to correctly predict the labels or categories of unseen " +
                        "graphs. " +
                        "A significant difficulty in this task arises when attempting to apply established " +
                        "classification " +
                        "algorithms due to the requirement for fixed size matrix or tensor representations of the " +
                        "graphs " +
                        "which may vary greatly in their numbers of nodes and edges. Building on prior work " +
                        "combining " +
                        "explicit tensor representations with a standard image-based classifier, we propose a " +
                        "model to " +
                        "perform graph classification by extracting fixed size tensorial information from each " +
                        "graph in a " +
                        "given set, and using a Capsule Network to perform classification. " +
                        "The graphs we consider here are undirected and with categorical features on the nodes. " +
                        "Using " +
                        "standard benchmarking chemical and protein datasets, we demonstrate that our graph " +
                        "Capsule " +
                        "Network classification model using an explicit tensorial representation of the graphs is " +
                        "competitive with current state of the art graph kernels and graph neural network models " +
                        "despite " +
                        "only limited hyper-parameter searching."}
                        pdf={"https://arxiv.org/pdf/1902.08399.pdf"}
                    />
                    <Publication
                        author={"Meltzer, P. and Bentley, P. J."}
                        date={"2018"}
                        title={"Interacting Hierarchical Dynamic Networks."}
                        conference={"In Proc. of the 2018 Conference on Artificial Life (ALIFE), Tokyo, Japan."}
                        abstract={"In this work we present IHDNs: an original model of computation " +
                        "for the simulation of interacting, dynamic, multi-scale " +
                        "systems. We show that a novel message passing mechanism " +
                        "that operates across layers of abstraction in hierarchical dynamic " +
                        "networks is effective in expressing the complex dependencies " +
                        "of living systems. Using a conventional computational " +
                        "model of cell evolution in cancerous tumour growth " +
                        "for comparison, we demonstrate the validity of IHDNs in " +
                        "emulating the behaviour of life-like systems, as well as the " +
                        "additional capabilities in enabling Neo4j Cypher pattern matching " +
                        "queries, demonstrated here in the analysis of evolutionary " +
                        "cell heritage."}
                        pdf={"http://s3-eu-west-1.amazonaws.com/braintree-ai/pdf/Interacting_Hierarchical_Dynamic_Networks_ALIFE2018.pdf"}
                    />
                </ul>

                <h2 className="mt-5">Projects</h2>
                <ul>
                    <li><strong>DeepGL for Neo4j</strong>
                        &mdash; An unsupervised graph representation learning algorithm implemented with <a
                            href="https://markhneedham.com/">Mark Needham</a> as a
                        <a href="https://neo4j.com/">Neo4j</a> database extension. [ <a
                            href="https://towardsdatascience.com/deepgl-on-neo4j-b27e8c64190f">Blog Post</a> &mdash;
                        <a href="https://github.com/neo4j-graph-analytics/ml-models">code</a> ]
                    </li>
                    <li><strong>Interacting Hierarchical Dynamic Networks</strong> [ <a
                        href="http://s3-eu-west-1.amazonaws.com/braintree-ai/pdf/Interacting_Hierarchical_Dynamic_Networks_ALIFE2018.pdf">PDF
                    </a> &mdash; <a href="http://github.com/meltzerpete/ihdn">code</a> ]
                    </li>
                    <li><strong>Systemic Graph Computation</strong> &mdash; Awarded the Peter William's prize at UCL for
                        best MSc Computer Science thesis. [ <a
                            href="assets/meltzer_final.pdf">PDF</a> &mdash; <a
                            href="http://github.com/meltzerpete/systemic-graph-computer">code</a> ]
                    </li>
                </ul>

                <a name="contact" id={"contact"}></a>
                <h2 className="mt-5">Contact</h2>
                <ul className="list-unstyled">

                    <li className="d-flex align-items-center"><span style={{fontSize: "2em"}}><i
                        className="far fa-envelope"></i></span>
                        &nbsp;&nbsp;
                        <a href="mailto:meltzerpete@gmail.com">meltzerpete@gmail.com</a></li>

                    <li className="d-flex align-items-center"><span style={{fontSize: "2em"}}><i
                        className="far fa-envelope"></i></span>
                        &nbsp;&nbsp;
                        <a href="mailto:p.meltzer@braintree.com">p.meltzer@braintree.com</a></li>

                    <li className="d-flex align-items-center"><span style={{fontSize: "2em"}}><i
                        className="fab fa-github"></i></span>
                        &nbsp;&nbsp;
                        <a href="http://github.com/meltzerpete">GitHub</a></li>

                    <li className="d-flex align-items-center"><span style={{fontSize: "2em"}}><i
                        className="fab fa-linkedin"></i></span>
                        &nbsp;&nbsp;
                        <a href="https://www.linkedin.com/in/pete-meltzer-400607148/">LinkedIn</a></li>
                </ul>
            </div>
        </div>
    )
}

export default Home;